var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big kefu_doctor"},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"no","border":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }